import React, { type CSSProperties } from 'react';
import { Button } from 'react-bootstrap';

import {
  appMaintenanceCheck,
  isMaintenanceModeError,
} from '../actions/auth';
import { disableMaintenanceBypass } from '../utils/maintenanceBypass';
import { useMaintenanceBypass } from '../utils/useMaintenanceBypass';

const MaintenanceBypassBanner = () => {
  const bypassEnabled = useMaintenanceBypass();

  const handleTurnOff = () => {
    disableMaintenanceBypass();

    appMaintenanceCheck(
      () => {},
      (error) => {
        if (isMaintenanceModeError(error)) {
          window.location.reload();
        }
      },
    );
  };

  if (!bypassEnabled) {
    return null;
  }

  return (
    <div style={styles.banner}>
      <span style={styles.text}>Maintenance bypass active</span>
      <Button
        size='sm'
        variant='outline-light'
        style={styles.button}
        onClick={handleTurnOff}>
        Turn off
      </Button>
    </div>
  );
};

const styles: { [key: string]: CSSProperties } = {
  banner: {
    alignItems: 'center',
    backgroundColor: '#E65100',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 20px',
    width: '100%',
    zIndex: 1020,
  },
  text: {
    color: '#FFFFFF',
    flex: 1,
    fontSize: 13,
    fontWeight: 600,
  },
  button: {
    borderColor: 'rgba(255, 255, 255, 0.6)',
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: 700,
    marginLeft: 12,
  },
};

export default MaintenanceBypassBanner;
